import { createFeatureSelector, createSelector } from '@ngrx/store';
import { fromRole } from '../reducers';
export const getRoleRootState = createFeatureSelector('role');
export const getRoleState = createSelector(getRoleRootState, (state) => state);
const roleSelectors = fromRole.roleAdapter.getSelectors(getRoleState);
export const getAllRoleItems = roleSelectors.selectAll;
export const getRoleEntities = roleSelectors.selectEntities;
/**
 * Selector to return the loaded property of the state
 */
export const getRolesLoaded = createSelector(getRoleState, fromRole.getRolesLoaded);
export const getRolesLoading = createSelector(getRoleState, fromRole.getRolesLoading);
//# sourceMappingURL=role.selectors.js.map